export default __webpack_public_path__ + "static/media/Banner Image.ba13ec78.png";